import { RigidBody } from '@react-three/rapier';
import { Pin } from './pin';
import { EndZone } from './end-zone';

export function Board() {
  const pins = [];
  const rows = 8;
  const cols = 8;
  const spacing = 2;
  const startX = -(cols * spacing) / 2;
  const startZ = -(rows * spacing) / 2;

  for (let row = 0; row < rows; row++) {
    const offset = row % 2 === 0 ? 0 : spacing / 2;
    for (let col = 0; col < cols; col++) {
      const x = startX + col * spacing + offset;
      const y = startZ + row * spacing;
      pins.push(<Pin key={`${row}-${col}`} position={[x, y, 0]} />);
    }
  }

  return (
    <group>
      {/* Left wall */}
      <RigidBody type="fixed">
        <mesh castShadow receiveShadow position={[startX - 2, startZ + (rows * spacing) / 2 - 1, 0]}>
          <boxGeometry args={[1, rows * spacing, 1]} />
          <meshStandardMaterial color="#444444" />
        </mesh>
      </RigidBody>

      {/* Right wall */}
      <RigidBody type="fixed">
        <mesh castShadow receiveShadow position={[startX + cols * spacing + 1, startZ + (rows * spacing) / 2 - 1, 0]}>
          <boxGeometry args={[1, rows * spacing, 1]} />
          <meshStandardMaterial color="#444444" />
        </mesh>
      </RigidBody>

      {/* Pins */}
      {pins}

      {/* End zones */}
      <EndZone position={[0, -35, 0]} size={[1000, 20, 100]} />
      <EndZone position={[0, 35, 0]} size={[1000, 20, 100]} />
    </group>
  );
}
